// src/vue/helpers/domain-text-config.js

export const domainConfig = {
  "portal.xracademy.online": {
    productName: "XR Academy",
    companyName: "Sam Media B.V.",
    supportEmail: "help@xracademy.online",
    privacyEmail: "privacy@ambglobaldigital.com",
    mccEmail: "info@ambglobaldigital.com",
    portfolioUrl: "www.xracademy.online",
  },
  "portal.xracademy.info": {
    productName: "XR Academy",
    companyName: "Mobimilia B.V.",
    supportEmail: "help@xracademy.info",
    privacyEmail: "privacy@ambglobaldigital.com",
    mccEmail: "info@ambglobaldigital.com",
    portfolioUrl: "www.xracademy.info",
  },
  "portal.immersi-learn.com": {
    productName: "Immersi Learn",
    companyName: "Pepperose LTD",
    supportEmail: "help@immersi-learn.com",
    privacyEmail: "privacy@pepperoseltd.com",
    mccEmail: "info@pepperoseltd.com",
    portfolioUrl: "www.immersi-learn.com",
    phoneNumber: "+44 1494 326040",
  },
  "portal.xrlab360.com": {
    productName: "XR Lab 360",
    companyName: "Pepperose LTD",
    supportEmail: "help@xrlab360.com",
    privacyEmail: "privacy@pepperoseltd.com",
    mccEmail: "info@pepperoseltd.com",
    portfolioUrl: "www.xrlab360.com",
    phoneNumber: "+44 1494 326040",
  },
  "portal.virtupaths.com": {
    productName: "Virtu Paths",
    companyName: "Pepperose LTD",
    supportEmail: "help@virtupaths.com",
    privacyEmail: "privacy@pepperoseltd.com",
    mccEmail: "info@pepperoseltd.com",
    portfolioUrl: "www.virtupaths.com",
    phoneNumber: "+44 1494 326040",
  },
  "portal.thenextgenxr.com": {
    productName: "The Next Gen XR",
    companyName: "Mobimilia B.V.",
    supportEmail: "help@thenextgenxr.com",
    privacyEmail: "privacy@mobimilia.com",
    mccEmail: "info@mobimilia.com",
    portfolioUrl: "www.thenextgenxr.com",
    phoneNumber: "+31 970 1020 8696",
  },
  "dz.xr-zone.co": {
    productName: "XR Zone",
  },
  "app.xrstudios.nl": {
    productName: "XR Studios",
    supportEmail: "nl-xrstudio@cchelp.co",
  },
  "rs.mobilnivr.com": {
    productName: "Mobilni VR",
  },
  "bh.xr-experience.co": {
    productName: "XR Experience",
  },
  "pt.academiavr.com": {
    productName: "Academia VR",
  },
  "ca.thevracademy.com": {
    productName: "The VR Academy",
  },
  "ch.vrxedge.com": {
    productName: "VRXEdge",
  },
  "portal.hkxr-a.com": {
    productName: "XR-A",
  },
  "sn.xr-lab.co": {
    productName: "XR Lab",
  },
  "ph.siklabxr.com": {
    productName: "siklabxr",
  },
  "portal.hkxr-a.com": {
    productName: "XR-A",
  },
  "app.aulaxr-mx.com": {
    productName: "aulaxr",
  },
  "gh.afri-verse.com": {
    productName: "Afri Verse",
  },
  "om.xr-discovery.com": {
    productName: "XR Discovery",
  },
  "qa.xr-exposure.com": {
    productName: "XR Exposure",
  },
  "eg.xr-vision.com": {
    productName: "XR Vision",
  },
  "app.labacademy-bh.com": {
    productName: "Lab Academy",
  },
  "ae.xr-edutainment.com": {
    productName: "XR Edutainment",
  },
  "th.xr-pulse.com": {
    productName: "XR Pulse",
  },
  "si.themelodymix.com": {
    productName: "themelodymix",
  },
  "si.xreduclass.com": {
    productName: "xreduclass",
  },
  "iq.xr-knowledge.com": {
    productName: "xr-knowledge",
  },
  "kw.academic-lab.com": {
    productName: "Academic Lab",
  },
  "iq.xrmadrasa.com": {
    productName: "XR Madrasa",
  },
  "jp.kasougakuen.com": {
    productName: "Kasougakuen",
  },
  // localhost: {
  //   productName: "aulaxr",
  //   companyName: "Mobimilia B.V.",
  //   supportEmail: "help@thenextgenxr.com",
  //   privacyEmail: "privacy@mobimilia.com",
  //   mccEmail: "info@mobimilia.com",
  //   portfolioUrl: "www.thenextgenxr.com",
  //   phoneNumber: "+31 970 1020 8696",
  // },
  // add more domains here...
};

/**
 * Replace all branded text (product name, company, email) according to the current hostname.
 * Falls back to returning the original text if no matching domainConfig entry is found.
 *
 * @param {string} text
 * @returns {string}
 */
export function replaceText(text) {
  if (typeof text !== "string") return text;

  const cfg = domainConfig[window.location.hostname];
  if (!cfg) return text;

  return text
    .replace(/XR Academy|XR AKADEMIJU/g, cfg.productName || "XR Academy")
    .replace(
      /AMB Global Digital Solutions LTD/g,
      cfg.companyName || "AMB Global Digital Solutions LTD"
    )
    .replace(/help@xr-academy.com/g, cfg.supportEmail || "help@xr-academy.com")
    .replace(
      /help@xr-academy.online/g,
      cfg.supportEmail || "/help@xr-academy.online"
    )
    .replace(
      /info@ambglobaldigital.com/g,
      cfg.mccEmail || "info@ambglobaldigital.com"
    )
    .replace(
      /www.immersi-learn.com/g,
      cfg.portfolioUrl || "www.immersi-learn.com"
    )
    .replace(
      /privacy@ambglobaldigital.com/g,
      cfg.privacyEmail || "privacy@ambglobaldigital.com"
    )
    .replace(/XR ACADEMY/g, cfg.productName || "XR ACADEMY")
    .replace(/\+44 1494 326040/g, cfg.phoneNumber || "+44 1494 326040")
    .replace(
      /(France: 0805 98 54 98 Spain: 900 751 051 Italy: 800 785 693)/g,
      cfg.phoneNumber ||
        "(France: 0805 98 54 98 Spain: 900 751 051 Italy: 800 785 693)"
    )
    .replace(
      /message that you received upon subscribing and the monthly SMS reminder from us/g,
      "email that you received upon subscribing"
    );
}
